import React from 'react';
import { BannerWrapper, FormSign, Wrapper } from './style';
import { world, logoVertical } from '../../assets';

const Index = (props) => {
  const { children } = props;

  return (
    <Wrapper>
      <BannerWrapper>
        <div className="component_banner_logo">
          <img src={`${logoVertical ?? ''}`} alt="banner sign" />
        </div>
        <div className="component_banner_image">
          <img src={world} alt="alphaveritas logo" width="100px" />
        </div>
        <div className="component_banner_footer">
          <div className="font-header3_medium black1">
            Manage your smart marketing with ease.
          </div>
          <div className="font-subtitle2 black3">
            One stop solution application for managing your online ads
          </div>
        </div>
      </BannerWrapper>
      <FormSign>{children}</FormSign>
    </Wrapper>
  );
};

export default Index;
